module.exports = __webpack_public_path__ + "img/icon-mark-as-review.57a4927e.svg";